// /app/frontend/src/data/bilansEleve.js
// Bilans synthétiques de fin de compétence REMC · contenu natif codevoiture.fr
// Réutilise la structure C1→C4 + un focus Intersections (transverse).

export const INTERSECTIONS_GRILLE = [
  { id: 'stop-d', pic: 'STOP ↑', label: 'STOP — tout droit' },
  { id: 'stop-g', pic: 'STOP ←', label: 'STOP — tourner à gauche' },
  { id: 'stop-dr', pic: 'STOP →', label: 'STOP — tourner à droite' },
  { id: 'cedez-d', pic: '⚠ ↑', label: 'Cédez le passage — tout droit' },
  { id: 'cedez-g', pic: '⚠ ←', label: 'Cédez le passage — tourner à gauche' },
  { id: 'cedez-dr', pic: '⚠ →', label: 'Cédez le passage — tourner à droite' },
  { id: 'pd-droite', pic: '↘', label: 'Priorité à droite (véhicule venant de droite)' },
  { id: 'pd-gauche', pic: '↙', label: 'Priorité à droite (véhicule venant de gauche)' },
  { id: 'feux-d', pic: '🚦 ↑', label: 'Feux tricolores — tout droit' },
  { id: 'feux-g', pic: '🚦 ←', label: 'Feux tricolores — tourner à gauche' },
  { id: 'feux-dr', pic: '🚦 →', label: 'Feux tricolores — tourner à droite' },
  { id: 'gir-entree', pic: '↻', label: 'Giratoire — entrée' },
  { id: 'gir-sortie2', pic: '↻2', label: 'Giratoire — sortie 2e' },
  { id: 'gir-sortie3', pic: '↻3', label: 'Giratoire — sortie 3e' },
  { id: 't-bas', pic: 'T ↑', label: 'Intersection en T — venant du bas' },
  { id: 't-droite', pic: 'T ←', label: 'Intersection en T — venant de la droite' },
  { id: 'insertion-d', pic: '⇢', label: "Carrefour avec voie d'insertion à droite" },
  { id: 'insertion-g', pic: '⇠', label: "Carrefour avec voie d'insertion à gauche" },
  { id: 'stockage-g', pic: '⎇←', label: 'Carrefour avec voie de stockage à gauche' },
  { id: 'stockage-d', pic: '⎇→', label: 'Carrefour avec voie de stockage à droite' },
  { id: 'ilot', pic: '◼', label: 'Carrefour avec îlot central / séparateur' },
  { id: 'indo', pic: '↶', label: "Carrefour à l'indonésienne (priorité au véhicule engagé)" },
  { id: 'prio', pic: '◆', label: 'Carrefour à sens prioritaire (route prioritaire)' },
  { id: 'fin-prio', pic: '◆̸', label: 'Fin de priorité' },
  { id: 'baio', pic: '⇄', label: 'Carrefour en baïonnette (priorité tournée)' },
  { id: 'tag-2t', pic: '②←', label: 'Tourne-à-gauche en deux temps' },
  { id: 'complexe', pic: '✦', label: 'Carrefour complexe (multi-branches)' },
  { id: 'acc-court', pic: '⇰', label: "Voie d'accélération courte (insertion difficile)" },
  { id: 'chicane', pic: '∿', label: 'Carrefour avec chicane / déport obligatoire' },
  { id: 'marq-sol', pic: '-|-', label: 'Carrefour avec priorité par marquage au sol seul' },
  { id: 'y', pic: 'Y', label: 'Carrefour en Y' },
  { id: 'x', pic: 'X', label: 'Carrefour en X (croisement large)' },
  { id: 'stop-2t', pic: 'STOP 2×', label: 'STOP avancé (ligne reculée — arrêt en 2 temps)' },
  { id: 'pieton', pic: '🚶', label: 'Intersection avec passage piéton proche' },
  { id: 'cycle', pic: '🚲', label: 'Intersection avec piste cyclable traversante' },
  { id: 'bus', pic: 'BUS', label: 'Intersection avec voie BUS / site propre' },
  { id: 'rural', pic: '🌲', label: 'Carrefour rural masqué (visibilité nulle)' },
];

export const BILAN_C1_SAVOIRS = [
  { section: 'C1a — Connaître les organes & effectuer les vérifications', items: [
    { code: '1.1', label: 'Connaître les principaux organes du véhicule' },
    { code: '1.2', label: 'Connaître les principales commandes et savoir les utiliser' },
    { code: '1.3', label: 'Savoir effectuer les vérifications intérieures et extérieures' },
  ]},
  { section: "C1b — Entrer, s'installer au poste de conduite et en sortir", items: [
    { code: '2.1', label: 'Savoir effectuer les contrôles autour du véhicule' },
    { code: '2.2', label: "Savoir entrer, s'installer et sortir du véhicule en sécurité" },
    { code: '2.3', label: 'Savoir installer les passagers, animaux et bagages' },
    { code: '2.4', label: "Connaître l'importance du rôle de la ceinture" },
  ]},
  { section: 'C1c — Tenir, tourner le volant et maintenir la trajectoire', items: [
    { code: '3.1', label: 'Savoir tenir et tourner le volant en ligne droite et en virage' },
    { code: '3.2', label: 'Savoir regarder pour diriger le véhicule' },
  ]},
  { section: "C1d — Démarrer et s'arrêter", items: [
    { code: '4.1', label: 'Savoir faire démarrer le véhicule sur terrain plat, en montée, en descente' },
    { code: '4.2', label: 'Savoir se déplacer à allure lente' },
    { code: '4.3', label: "Savoir s'arrêter avec précision" },
  ]},
  { section: "C1e — Doser l'accélération et le freinage", items: [
    { code: '5.1', label: "Savoir doser l'accélération" },
    { code: '5.2', label: 'Savoir doser le freinage à diverses allures' },
  ]},
  { section: 'C1f — Utiliser la boîte de vitesses', items: [
    { code: '6.1', label: 'Savoir manipuler le levier de vitesses sans le regarder' },
    { code: '6.2', label: 'Savoir monter les vitesses et rétrograder' },
    { code: '6.3', label: 'Savoir choisir le rapport de vitesse convenable' },
  ]},
  { section: 'C1g — Diriger la voiture en avant', items: [
    { code: '7.1', label: 'Savoir maintenir une trajectoire rectiligne et en courbe à diverses allures' },
  ]},
  { section: 'C1h — Regarder autour de soi et avertir', items: [
    { code: '8.1', label: 'Connaître les angles morts' },
    { code: '8.2', label: 'Savoir regarder dans les rétroviseurs et avertir' },
    { code: '8.3', label: 'Avoir des notions sur la direction et la mobilité du regard' },
  ]},
  { section: 'C1i — Effectuer une marche arrière et un demi-tour en sécurité', items: [
    { code: '9.1', label: 'Savoir effectuer une marche arrière en sécurité' },
    { code: '9.2', label: 'Savoir effectuer un demi-tour en sécurité' },
    { code: '9.3', label: 'Savoir faire une marche arrière en ligne droite et en courbe' },
  ]},
];

export const BILAN_C2_SAVOIRS = [
  { section: 'C2a — Rechercher la signalisation, les indices utiles et en tenir compte', items: [
    { code: '10.1', label: 'Connaître les principaux panneaux de signalisation et les feux tricolores' },
    { code: '10.2', label: 'Savoir rechercher les informations utiles et en tenir compte' },
    { code: '10.3', label: 'Savoir identifier les indices formels et informels' },
  ]},
  { section: 'C2b — Positionner le véhicule sur la chaussée et choisir la voie de circulation', items: [
    { code: '11.1', label: 'Savoir suivre la voie de circulation à allure normale' },
    { code: '11.2', label: 'Connaître les règles de positionnement sur la chaussée' },
    { code: '11.3', label: 'Savoir choisir la voie de circulation appropriée' },
  ]},
  { section: 'C2c — Adapter l\'allure aux situations', items: [
    { code: '12.1', label: 'Connaître les limitations de vitesse selon les voies et catégories' },
    { code: '12.2', label: 'Savoir adapter sa vitesse à la situation et à l\'environnement' },
    { code: '12.3', label: 'Connaître et respecter les distances de sécurité' },
  ]},
  { section: 'C2d — Tourner à droite et à gauche en agglomération', items: [
    { code: '13.1', label: 'Savoir tourner à droite en agglomération' },
    { code: '13.2', label: 'Savoir tourner à gauche en agglomération' },
    { code: '13.3', label: 'Savoir s\'insérer dans un flux de circulation' },
  ]},
  { section: 'C2e — Détecter, identifier et franchir les intersections suivant le régime de priorité', items: [
    { code: '14.1', label: 'Connaître les règles générales de priorité aux intersections' },
    { code: '14.2', label: 'Savoir franchir une intersection à priorité à droite' },
    { code: '14.3', label: 'Savoir franchir une intersection avec STOP ou cédez-le-passage' },
    { code: '14.4', label: 'Savoir franchir un carrefour à feux et un giratoire' },
  ]},
  { section: 'C2f — Franchir les ronds-points et les carrefours à sens giratoire', items: [
    { code: '15.1', label: 'Connaître la différence entre rond-point et carrefour à sens giratoire' },
    { code: '15.2', label: 'Savoir entrer, circuler et sortir d\'un giratoire en sécurité' },
  ]},
  { section: 'C2g — S\'arrêter et stationner en épi, en bataille et en créneau', items: [
    { code: '16.1', label: 'Connaître la signalisation relative à l\'arrêt et au stationnement' },
    { code: '16.2', label: 'Savoir s\'arrêter et stationner en épi, en bataille et en créneau' },
    { code: '16.3', label: 'Savoir vérifier la sécurité avant ouverture de portière (réflexe néerlandais)' },
  ]},
];

export const BILAN_C3_SAVOIRS = [
  { section: 'C3a — Évaluer et maintenir les distances de sécurité', items: [
    { code: '17.1', label: 'Connaître la notion de temps de réaction et la formule des distances' },
    { code: '17.2', label: 'Savoir évaluer et maintenir les distances de sécurité' },
    { code: '17.3', label: 'Savoir adapter les distances aux conditions (pluie, nuit, charge)' },
  ]},
  { section: 'C3b — Croiser, dépasser, être dépassé', items: [
    { code: '18.1', label: 'Connaître les règles du croisement et savoir s\'effacer' },
    { code: '18.2', label: 'Connaître les règles du dépassement et savoir l\'effectuer' },
    { code: '18.3', label: 'Savoir se faire dépasser en sécurité' },
  ]},
  { section: 'C3c — Passer des virages et conduire en déclivité', items: [
    { code: '19.1', label: 'Savoir aborder, négocier et sortir d\'un virage' },
    { code: '19.2', label: 'Savoir conduire en montée et en descente (frein moteur, freinage long)' },
  ]},
  { section: 'C3d — Connaître les caractéristiques des autres usagers et savoir se comporter à leur égard', items: [
    { code: '20.1', label: 'Connaître les caractéristiques des piétons et savoir se comporter' },
    { code: '20.2', label: 'Connaître les caractéristiques des cyclistes et savoir se comporter (1,5 m d\'écart)' },
    { code: '20.3', label: 'Connaître les caractéristiques des cyclomoteurs / motocyclistes et savoir se comporter' },
    { code: '20.4', label: 'Connaître les caractéristiques des poids lourds et savoir se comporter (angles morts)' },
  ]},
  { section: 'C3e — S\'adapter aux conditions de conduite et aux conditions climatiques', items: [
    { code: '21.1', label: 'Savoir adapter sa conduite à la pluie, au brouillard, à la neige' },
    { code: '21.2', label: 'Savoir adapter sa conduite à la nuit (feux, éblouissement)' },
    { code: '21.3', label: 'Savoir adapter sa conduite sur chaussée glissante' },
  ]},
  { section: 'C3f — Conduire en agglomération, en circulation dense, sur route et sur autoroute', items: [
    { code: '22.1', label: 'Savoir conduire en agglomération et en circulation dense' },
    { code: '22.2', label: 'Savoir conduire sur route (départementale, nationale)' },
    { code: '22.3', label: 'Savoir entrer, circuler et sortir d\'une autoroute' },
  ]},
];

export const BILAN_C4_SAVOIRS = [
  { section: 'C4a — Suivre un itinéraire de manière autonome', items: [
    { code: '23.1', label: 'Savoir préparer et suivre un itinéraire à l\'aide de panneaux directionnels' },
    { code: '23.2', label: 'Savoir utiliser un GPS sans détourner l\'attention de la route' },
    { code: '23.3', label: 'Savoir conduire en autonomie sur un trajet inconnu' },
  ]},
  { section: 'C4b — Préparer et effectuer un voyage longue distance en autonomie', items: [
    { code: '24.1', label: 'Savoir préparer un voyage (itinéraire, météo, état du véhicule)' },
    { code: '24.2', label: 'Connaître les règles d\'hygiène de conduite (pauses 2 h, hydratation, sommeil)' },
    { code: '24.3', label: 'Savoir gérer la fatigue et la somnolence au volant' },
  ]},
  { section: 'C4c — Connaître les principaux facteurs de risques au volant, les recommandations à appliquer', items: [
    { code: '25.1', label: 'Connaître les effets de l\'alcool, des stupéfiants et des médicaments' },
    { code: '25.2', label: 'Connaître les risques liés au téléphone, à la fatigue et aux distractions' },
    { code: '25.3', label: 'Connaître les sanctions et les conséquences d\'une infraction' },
  ]},
  { section: 'C4d — Connaître les comportements à adopter en cas d\'accident : protéger, alerter, secourir', items: [
    { code: '26.1', label: 'Savoir protéger les lieux d\'un accident (triangle, gilet, baliser)' },
    { code: '26.2', label: 'Savoir alerter les secours (112, position, nombre de victimes)' },
    { code: '26.3', label: 'Connaître les premiers gestes de secours (PAS : Protéger-Alerter-Secourir)' },
  ]},
  { section: 'C4e — Faire l\'expérience des aspects environnementaux liés à l\'usage de l\'automobile', items: [
    { code: '27.1', label: 'Connaître les principes de l\'éco-conduite (anticipation, régime moteur, vitesse)' },
    { code: '27.2', label: 'Savoir pratiquer une conduite économique et écologique' },
    { code: '27.3', label: 'Connaître les alternatives à la voiture individuelle (covoiturage, transports en commun)' },
  ]},
  { section: 'C4f — Pratiquer une conduite autonome, sûre et économique', items: [
    { code: '28.1', label: 'Savoir conduire 25-30 min en autonomie sans intervention de l\'enseignant' },
    { code: '28.2', label: 'Savoir auto-évaluer sa conduite et identifier ses points faibles' },
    { code: '28.3', label: 'Savoir gérer le stress et les imprévus en conduite autonome' },
  ]},
];

export const BILANS = [
  {
    code: 'C1',
    title: 'Maîtriser le maniement du véhicule',
    color: 'sky',
    duree: '15 à 25 h de pratique',
    objectif: 'À la fin de C1, tu dois pouvoir conduire le véhicule en sécurité dans des conditions simples. Évalue chaque savoir : Acquis · À améliorer · Non acquis.',
    interactive: true,
    sections: BILAN_C1_SAVOIRS,
  },
  {
    code: 'C2',
    title: 'Appréhender la route et la circulation',
    color: 'amber',
    duree: '15 à 25 h de pratique',
    objectif: "À la fin de C2, tu sais lire la signalisation, appliquer les règles de priorité et coexister avec les autres usagers dans des conditions normales. Évalue chaque savoir : Acquis · À améliorer · Non acquis.",
    interactive: true,
    sections: BILAN_C2_SAVOIRS,
  },
  {
    code: 'C3',
    title: 'Circuler dans des conditions difficiles et partager la route',
    color: 'red',
    duree: '10 à 20 h de pratique',
    objectif: "À la fin de C3, tu sais adapter ta conduite à la pluie, la nuit, l'autoroute, les routes étroites, les passagers et coexister avec tous les usagers. Évalue chaque savoir : Acquis · À améliorer · Non acquis.",
    interactive: true,
    sections: BILAN_C3_SAVOIRS,
  },
  {
    code: 'C4',
    title: 'Pratiquer une conduite autonome, sûre et économique',
    color: 'emerald',
    duree: '5 à 15 h selon parcours',
    objectif: "À la fin de C4, tu es prêt(e) à conduire SEUL(E) : suivre un itinéraire, gérer une panne, économiser le carburant, réagir à un accident. Évalue chaque savoir : Acquis · À améliorer · Non acquis.",
    interactive: true,
    sections: BILAN_C4_SAVOIRS,
  },
  {
    code: 'FOCUS',
    title: 'Focus Intersections — grille d\'évaluation',
    color: 'red',
    duree: 'Transverse · à pratiquer dans toutes les sorties',
    objectif: "60 % des accidents urbains ont lieu en intersection. Coche pour chaque type de carrefour : Acquis · À améliorer · Non acquis. L'évaluation finale s'affiche en temps réel.",
    interactive: true,
  },
];
